import Axios from './config';

class MembershipApi {
    static createCustomerMembership(data) {
        return Axios({
            method: 'POST',
            url: '/customer-membership',
            data
        })
            .then(res => {
                if (res.data.success) {
                    return { data: res.data, success: true };
                } else {
                    return {
                        success: false,
                        message: 'Membership could not be created. Please contact Collums Support'
                    };
                }
            })
            .catch(err => {
                if (Array.isArray(err?.response?.data?.validation?.keys)) {
                    const mapper = {
                        name: 'Name',
                        firstPayment: 'Date of first payment',
                        amount: 'Monthly amount',
                        customer: 'Customer',
                        numberOfPayments: 'No of monthly payments'
                    };

                    const invalidFields = err?.response?.data?.validation?.keys.map(field => mapper[field]);

                    let message = `Field${invalidFields.length === 1 ? '' : 's'} ${invalidFields.join(
                        ','
                    )} must contain proper value`;
                    return { success: false, message };
                }
            });
    }

    static voidDirectDebit(data) {
        return Axios({
            method: 'POST',
            url: '/coherent/direct-debit-status',
            data: { ...data, status: 'void' }
        })
            .then(res => {
                if (res.data.success) {
                    return { data: res.data, success: true };
                } else {
                    return {
                        success: false,
                        message: 'Direct debit was cancelled'
                    };
                }
            })
            .catch(() => {
                return { success: false, message: 'Direct debit cancel failed' };
            });
    }
}

export const listMemberships = async clinicId => {
    const result = await Axios({
        method: 'GET',
        url: `/membership?clinic=${clinicId}&isFromOrg=false&pageSize=100`
    });
    return result.data.memberships || [];
};

export const listCustomerMemberships = async ({ customer, order, page, rowsPerPage }) => {
    const result = await Axios({
        method: 'GET',
        url: `/direct-debits/customer?customerId=${customer}&order=${order}&page=${page}&rowsPerPage=${rowsPerPage}`
    });

    return result.data;
};

export const getCustomerMembershipsForRedemption = async (customerId, clinicId, excludeExpired = false) => {
    const result = await Axios({
        method: 'GET',
        url: `/customer-membership/for-redemption?customerId=${customerId}&clinic=${clinicId}&excludeExpired=${excludeExpired}`
    });
    return result.data;
};

export const getCustomerMembershipStatus = async membershipId => {
    const result = await Axios({
        method: 'GET',
        url: `/customer-membership/${membershipId}/status`
    });
    return result.data;
};

export const pauseMembership = async membershipId => {
    const result = await Axios({
        method: 'POST',
        url: '/coherent/direct-debit-status',
        data: { itemId: membershipId, type: 'membership', status: 'paused' }
    });
    return result.data;
};

export const restartMembership = async membershipId => {
    const result = await Axios({
        method: 'POST',
        url: '/coherent/direct-debit-status',
        data: { itemId: membershipId, type: 'membership', status: 'resumed' }
    });
    return result.data;
};

export const cancelMembership = async membershipId => {
    const result = await Axios({
        method: 'POST',
        url: `/customer-membership/${membershipId}/cancel`
    });
    return result.data;
};

export const redeemMembershipService = async (membershipId, serviceIndex) => {
    const result = await Axios({
        method: 'PUT',
        url: `/customer-membership/${membershipId}/redeem`,
        data: { serviceIndex }
    });
    return result.data;
};

export const unredeemMembershipService = async (membershipId, serviceIndex) => {
    const result = await Axios({
        method: 'PUT',
        url: `/customer-membership/${membershipId}/unredeem`,
        data: { serviceIndex }
    });
    return result.data;
};

export const reattemptDirectDebitPayment = async (itemId, type) => {
    const result = await Axios({
        method: 'POST',
        url: '/coherent/reattempt-dd-payment',
        data: { itemId, type }
    });
    return result.data;
};

export const simulateAuthorize = async (customerMembershipId, simulateDate) => {
    const data = { customerMembershipId, action: 'authorize' };
    if (simulateDate) data.simulateDate = simulateDate;
    const result = await Axios({
        method: 'POST',
        url: '/coherence/webhook/simulate',
        data
    });
    return result.data;
};

export const simulatePaymentReceived = async (customerMembershipId, simulateDate) => {
    const data = { customerMembershipId, action: 'payment_received' };
    if (simulateDate) data.simulateDate = simulateDate;
    const result = await Axios({
        method: 'POST',
        url: '/coherence/webhook/simulate',
        data
    });
    return result.data;
};

export const simulateInsufficientFunds = async customerMembershipId => {
    const result = await Axios({
        method: 'POST',
        url: '/coherence/webhook/simulate',
        data: { customerMembershipId, action: 'insufficient_funds' }
    });
    return result.data;
};

export default MembershipApi;
